var _a, _b;
import { CompactType, DisplayGrid, GridType } from 'angular-gridster2';
import { PercentComponent } from './percent/percent.component';
import { CallQueueComponent } from './call-queue/call-queue.component';
import { UsersComponent } from './users/users.component';
import { InboundCallsComponent } from './inbound-calls/inbound-calls.component';
import { OutboundCallsComponent } from './outbound-calls/outbound-calls.component';
export var dashboardOptions = {
    gridType: GridType.VerticalFixed,
    compactType: CompactType.None,
    margin: 16,
    outerMargin: false,
    outerMarginTop: null,
    outerMarginRight: null,
    outerMarginBottom: null,
    outerMarginLeft: null,
    mobileBreakpoint: 760,
    minCols: 1,
    maxCols: 100,
    minRows: 1,
    maxRows: 100,
    maxItemCols: 100,
    minItemCols: 1,
    maxItemRows: 100,
    minItemRows: 1,
    maxItemArea: 2500,
    minItemArea: 1,
    defaultItemCols: 1,
    defaultItemRows: 1,
    fixedRowHeight: 190,
    keepFixedHeightInMobile: true,
    keepFixedWidthInMobile: false,
    scrollSensitivity: 10,
    scrollSpeed: 20,
    enableEmptyCellClick: true,
    enableEmptyCellContextMenu: false,
    enableEmptyCellDrop: false,
    enableEmptyCellDrag: false,
    emptyCellDragMaxCols: 50,
    emptyCellDragMaxRows: 50,
    ignoreMarginInRow: false,
    draggable: {
        enabled: false
    },
    resizable: {
        enabled: false
    },
    swap: false,
    pushItems: true,
    disablePushOnDrag: false,
    disablePushOnResize: false,
    pushDirections: { north: true, east: true, south: true, west: true },
    pushResizeItems: false,
    displayGrid: DisplayGrid.OnDragAndResize,
    disableWindowResize: false,
    disableWarnings: false,
    scrollToNewItems: false
};
export var dynamicComponent;
(function (dynamicComponent) {
    dynamicComponent["InboundCallsComponent"] = "InboundCallsComponent";
    dynamicComponent["OutboundCallsComponent"] = "OutboundCallsComponent";
    dynamicComponent["PercentComponent"] = "PercentComponent";
    dynamicComponent["CallQueueComponent"] = "CallQueueComponent";
    dynamicComponent["UsersComponent"] = "UsersComponent";
})(dynamicComponent || (dynamicComponent = {}));
export var dynamicComponents = (_a = {},
    _a[dynamicComponent.InboundCallsComponent] = InboundCallsComponent,
    _a[dynamicComponent.OutboundCallsComponent] = OutboundCallsComponent,
    _a[dynamicComponent.PercentComponent] = PercentComponent,
    _a[dynamicComponent.CallQueueComponent] = CallQueueComponent,
    _a[dynamicComponent.UsersComponent] = UsersComponent,
    _a);
export var dynamicComponentsInputs = (_b = {},
    _b[dynamicComponent.InboundCallsComponent] = {},
    _b[dynamicComponent.OutboundCallsComponent] = {},
    _b[dynamicComponent.PercentComponent] = {
        value: 0,
        valueYesterday: 0
    },
    _b[dynamicComponent.CallQueueComponent] = [],
    _b[dynamicComponent.UsersComponent] = [],
    _b);
